/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#pie[_ngcontent-%COMP%]{height:20px;font-size:12px}\n/*# sourceMappingURL=footer.component.css.map*/"];
export { styles as styles };
